

import img1 from '../Images/Vector (2).png';
import img2 from '../Images/Vector (1).png';
import img3 from '../Images/Vector (7).png';
import img4 from '../Images/Vector (8).png';
import img5 from '../Images/Vector (10).png';
import img6 from '../Images/Vector (11).png';
import img7 from '../Images/img2.png';
import img8 from '../Images/img3.png';
import img9 from '../Images/img6.png';
import img10 from '../Images/img4.png';
import img11 from '../Images/img9.png';
import img12 from '../Images/img7.png';
import asset1 from '../Images/Bed (1).svg';
import asset2 from '../Images/Shape.png';
import asset3 from '../Images/Size.svg';
import img13 from '../Images/officeimg1.webp';
import img14 from '../Images/officeimg3.webp';
import img15 from '../Images/officeimg4.jpeg';


export const navbarData = [
    {
        text:'Home'
    },
    {
        text:'Landlord'
    },
    {
        text:'Tenants'
    },
    {
        text:'Contact'
    }
]



export const aboutData = [
    {
        img: img1,
        text:'Pay as Little as possible !' 
    },
   {
    img:img2,
    text:'Enjoy wisdom of community !'
   },
   {
    img:img3,
    text:`Let's somebody else  take care of Landlord !`
   },
   {
    img:img4,
    text:'Enjoy peaceful environment !'
   },
   {
    img:img5,
    text:'stay safe ! save money !'
   },
   {
    img:img6,
    text:'pay for what you use !'
   },
]


export const propertyData = [
    {
        img:img7,
        address:'2578 Folsom street,San Francisco, CA, 94110',
        text:'Private Room',
        price:'$1200/Month',
        asset1:asset1,
        num1:4,
        asset2:asset2,
        num2:2,
        asset3:asset3,
        num3:3,
    },
    {
        img:img8,
        address:'2578 Folsom street,San Francisco, CA, 94110',
        text:'Private Room',
        price:'$1200/Month',
        asset1:asset1,
        num1:4,
        asset2:asset2,
        num2:2,
        asset3:asset3,
        num3:3,
    },
    {
        img:img9,
        address:'2578 Folsom street,San Francisco, CA, 94110',
        text:'Private Room',
        price:'$1200/Month',
        asset1:asset1,
        num1:4,
        asset2:asset2,
        num2:2,
        asset3:asset3,
        num3:3,
    },
    {
        img:img10,
        address:'2578 Folsom street,San Francisco, CA, 94110',
        text:'Private Room',
        price:'$1200/Month',
        asset1:asset1,
        num1:4,
        asset2:asset2,
        num2:2,
        asset3:asset3,
        num3:3,
    },
    {
        img:img11,
        address:'2578 Folsom street,San Francisco, CA, 94110',
        text:'Private Room',
        price:'$1200/Month',
        asset1:asset1,
        num1:4,
        asset2:asset2,
        num2:2,
        asset3:asset3,
        num3:3,
    },
    {
        img:img12,
        address:'2578 Folsom street,San Francisco, CA, 94110',
        text:'Private Room',
        price:'$1200/Month',
        asset1:asset1,
        num1:4,
        asset2:asset2,
        num2:2,
        asset3:asset3,
        num3:3,
    },
]


export const founderData = [
    {
        text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam interdum nisl et nunc facilisis, a commodo eros mollis. Nunc vel pellentesque est. Curabitur at odio sit amet libero vulputate efficitur ac nec justo. Nulla vitae mauris quam. Nulla quam massa, faucibus id pretium ac, mattis eu velit. Donec sed risus a lacus fringilla finibus.',
        img:img13,
        name:'Harry Wilson',
        job:'Property Owner'
    },
    {
        text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam interdum nisl et nunc facilisis, a commodo eros mollis. Nunc vel pellentesque est. Curabitur at odio sit amet libero vulputate efficitur ac nec justo. Nulla vitae mauris quam. Nulla quam massa.',
        img:img14,
        name:'Dorathy Blake',
        job:'Property Supervisor'
    },
    {
        text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam interdum nisl et nunc facilisis, a commodo eros mollis. Nunc vel pellentesque est. Curabitur at odio sit amet libero vulputate efficitur ac nec justo. Nulla vitae mauris quam. Nulla quam massa, faucibus id pretium ac, mattis eu velit. Donec sed risus a lacus fringilla finibus.',
        img:img15,
        name:'Abubakar Abdul',
        job:'Property Manager'
    },
]


